/**
 * CAMO COSMETICS — LUXURY WEB & SKINAI ENGINE
 * MULTI-PLATFORM CART ENGINE (SHOPIFY + WOOCOMMERCE + STANDALONE)
 */

// CAMO Global Namespace
window.camoApp = window.camoApp || {};

let heroCurrentIndex = 0;
let heroAutoplayTimer = null;
const HERO_AUTOPLAY_DELAY = 5500;

function camoGetAssetUrl(filename) {
  const cleanName = filename.replace(/^assets\//, '');
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.assets_url) {
    return window.CAMO_WP.assets_url + cleanName;
  }
  return 'assets/' + cleanName;
}

// Product slug to WooCommerce ID mapping
const CAMO_PRODUCT_IDS = {
  'camo-calm-mist': 732,
  'camo-calm-serum': 724,
  'reti-glow': 667,
  'niacinamide': 642,
  'peeling-enzimatico': 0,
  'purifying-mousse': 616,
  'lip-mask': 407,
};

const CAMO_PRODUCTS = {
  'camo-calm-mist': {
    id: 'camo-calm-mist',
    wc_id: 732,
    name: 'CAMO CALM Barrier Defense Mist',
    subtitle: 'Prebióticos, Ácido Hialurónico & Sodium PCA',
    price: 27.00,
    volume: '100 ml',
    get image() { return camoGetAssetUrl('product_camo_calm_mist.png'); },
    category: 'Bruma Facial & Barrera Cutánea',
    rating: 4.96,
    reviewCount: 52,
    shortDesc: 'Bruma facial ultraligera que hidrata, refresca y fortalece la barrera cutánea al instante.',
    fullDesc: 'Refresca, hidrata y protege tu piel con CAMO CALM Microbiome Prebiotics Barrier Defense Mist, una bruma facial formulada para fortalecer la barrera cutánea y favorecer el equilibrio del microbioma.',
    benefits: ['Hidrata y refresca al instante', 'Fortalece la barrera cutánea', 'Equilibra el microbioma', 'Apta para todo tipo de piel'],
    howToUse: 'Pulverizar sobre el rostro a 20-30 cm con los ojos cerrados tras la limpieza, antes/después del maquillaje o durante el día.',
    keyIngredients: [
      { name: 'Prebióticos Bioactivos', desc: 'Equilibran el microbioma cutáneo y fortalecen la barrera natural.' },
      { name: 'Ácido Hialurónico', desc: 'Aporte de hidratación inmediata y elasticidad prolongada.' },
      { name: 'Sodium PCA', desc: 'Factor de hidratación natural (NMF) que retiene el agua celular.' }
    ]
  },
  'camo-calm-serum': {
    id: 'camo-calm-serum',
    wc_id: 724,
    name: 'CAMO CALM Prebiotics Serum',
    subtitle: 'Reparador de la Barrera Cutánea & Prebióticos Bio',
    price: 25.00,
    volume: '30 ml',
    get image() { return camoGetAssetUrl('product_camo_calm_serum.png'); },
    category: 'Tratamiento Calma & Barrera',
    rating: 4.94,
    reviewCount: 48,
    shortDesc: 'Sérum textura gel que repara la barrera cutánea, refuerza el microbioma y calma rojeces.',
    fullDesc: 'Su avanzada fórmula combina prebióticos, ácido hialurónico y Sodium PCA para reparar la barrera cutánea debilitada, calmar la tirantez y devolver suavidad sin sensación grasa.',
    benefits: ['Repara la barrera cutánea', 'Calma tirantez y rojeces', 'Hidratación profunda sin grasa', 'Ideal piel sensible'],
    howToUse: 'Aplicar 2 a 4 gotas sobre la piel limpia y seca del rostro y cuello, mañana y noche.',
    keyIngredients: [
      { name: 'Prebióticos Bioactivos', desc: 'Favorecen el equilibrio del microbioma y reducen la reactividad.' },
      { name: 'Ácido Hialurónico Puro', desc: 'Hidrata en profundidad y suaviza la piel.' },
      { name: 'Sodium PCA', desc: 'Conserva el agua celular evitando la deshidratación.' }
    ]
  },
  'reti-glow': {
    id: 'reti-glow',
    wc_id: 667,
    name: 'Reti-Glow Serum Oil',
    subtitle: 'Bakuchiol 1%, Aceites Naturales de Frambuesa y Arándanos',
    price: 79.00,
    volume: '30 ml',
    get image() { return camoGetAssetUrl('product_reti_glow.png'); },
    category: 'Tratamiento Luminosidad & Firmeza',
    rating: 4.98,
    reviewCount: 142,
    shortDesc: 'Aceite facial botánico con Bakuchiol 1% (alternativa natural al retinol). No fotosensible.',
    fullDesc: 'Tratamiento antiedad global de rápida absorción. El Bakuchiol al 1% estimula la síntesis de colágeno y la renovación celular sin causar irritación ni fotosensibilidad.',
    benefits: ['Reduce líneas de expresión', 'Aumenta elasticidad y firmeza', 'No irrita ni descama', 'Uso día y noche'],
    howToUse: 'Aplicar 3-4 gotas sobre rostro y cuello limpios, mañana y noche.',
    keyIngredients: [
      { name: 'Bakuchiol 1%', desc: 'Retinol vegetal de máxima tolerancia que acelera la renovación celular.' },
      { name: 'Aceite de Frambuesa', desc: 'Rico en Vitamina E y ácidos grasos esenciales omega 3 y 6.' },
      { name: 'Aceite de Semilla de Arándano', desc: 'Potente antioxidante que combate el daño oxidativo.' }
    ]
  },
  'niacinamide': {
    id: 'niacinamide',
    wc_id: 642,
    name: 'Niacinamide Gel Moisturiser',
    subtitle: 'Niacinamida 5%, Ácido Hialurónico & Cafeína',
    price: 49.00,
    volume: '50 ml',
    get image() { return camoGetAssetUrl('product_niacinamide_gel.png'); },
    category: 'Hidratación & Control de Poros',
    rating: 4.91,
    reviewCount: 98,
    shortDesc: 'Gel hidratante ultraligero que equilibra la producción de sebo, atenúa manchas y minimiza poros.',
    fullDesc: 'Fórmula hidratante en gel diseñada para pieles mixtas, grasas o con tendencia a imperfecciones. La Niacinamida al 5% regula el sebo mientras descongestiona la dermis.',
    benefits: ['Controla brillos durante 12h', 'Minimiza apariencia de poros', 'Atenúa manchas post-acné', 'Textura gel invisible'],
    howToUse: 'Extender una pequeña cantidad sobre rostro y cuello tras el sérum, mañana y noche.',
    keyIngredients: [
      { name: 'Niacinamida 5%', desc: 'Vitamina B3 que fortalece la barrera y regula el sebo.' },
      { name: 'Ácido Hialurónico Multimolecular', desc: 'Hidratación sin aportar grasa.' },
      { name: 'Extracto de Cafeína', desc: 'Efecto descongestivo y revitalizante.' }
    ]
  },
  'peeling-enzimatico': {
    id: 'peeling-enzimatico',
    wc_id: 0,
    name: 'Peeling Enzimático Facial',
    subtitle: 'Enzimas de Granada, Papaya & Polvo de Arroz',
    price: 36.00,
    volume: '75 ml',
    get image() { return camoGetAssetUrl('product_peeling_enzimatico.png'); },
    category: 'Exfoliación Suave & Renovación',
    rating: 4.95,
    reviewCount: 67,
    shortDesc: 'Exfoliante no abrasivo que disuelve células muertas mediante acción enzimática botánica.',
    fullDesc: 'Renovador cutáneo biológico sin micropartículas agresivas. Las enzimas naturales de granada y papaya descomponen las células queratinizadas superficiales.',
    benefits: ['Exfoliación no mecánica', 'Apto para pieles con rojeces o acné', 'Luminosidad inmediata', 'Mejora absorción de tratamientos'],
    howToUse: 'Aplicar una fina capa sobre la piel limpia. Dejar actuar 5-7 minutos y retirar con agua tibia.',
    keyIngredients: [
      { name: 'Enzimas de Granada Fermentada', desc: 'Disuelven los enlaces de queratina celular suavemente.' },
      { name: 'Papaína Activa', desc: 'Enzima purificante que limpia el poro en profundidad.' },
      { name: 'Polvo de Arroz Micronizado', desc: 'Aporta suavidad extrema y calma la piel.' }
    ]
  },
  'purifying-mousse': {
    id: 'purifying-mousse',
    wc_id: 616,
    name: 'Purifying Mousse Cleanser',
    subtitle: 'Agua de Rosas, Pepino & Tensioactivos de Coco',
    price: 32.00,
    volume: '150 ml',
    get image() { return camoGetAssetUrl('product_purifying_mousse.png'); },
    category: 'Limpieza Botánica & Frescura',
    rating: 4.89,
    reviewCount: 84,
    shortDesc: 'Espuma limpiadora sedosa que elimina impurezas sin alterar el manto lipídico.',
    fullDesc: 'Mousse limpiadora con pH 5.5 formulada con hidrolato de rosas biológicas y extracto de pepino. Suave y reconfortante, limpia en profundidad sin sensación de tirantez.',
    benefits: ['Limpieza profunda sin tirantez', 'Respeta el pH cutáneo', 'Elimina polución urbana', 'Espuma ultra cremosa'],
    howToUse: 'Dispensar 1-2 pulsaciones sobre manos húmedas, masajear el rostro y aclarar.',
    keyIngredients: [
      { name: 'Hidrolato de Rosa Damascena', desc: 'Tonifica, calma y suaviza la piel durante el lavado.' },
      { name: 'Extracto de Pepino', desc: 'Aporta frescura, hidrata y descongestiona la tez.' },
      { name: 'Tensioactivos Suaves de Coco', desc: 'Agentes limpiadores biodegradables que no resecan.' }
    ]
  },
  'lip-mask': {
    id: 'lip-mask',
    wc_id: 407,
    name: 'Lip Sleeping Mask',
    subtitle: 'Manteca de Karité, Péptidos & Frutos Rojos',
    price: 22.00,
    volume: '15 ml',
    get image() { return camoGetAssetUrl('product_lip_mask.png'); },
    category: 'Bálsamo Labial Reparador Nocturno',
    rating: 4.97,
    reviewCount: 110,
    shortDesc: 'Tratamiento labial intensivo que repara grietas y nutre en profundidad mientras duermes.',
    fullDesc: 'Mascarilla labial de textura fundente rica en manteca de karité, cera botánica y péptidos redensificantes. Crea una película protectora que retiene la humedad toda la noche.',
    benefits: ['Repara labios agrietados en 1 noche', 'Efecto volumen y suavidad', 'Sabor natural a frutos del bosque', 'Acabado brillo no pegajoso'],
    howToUse: 'Aplicar una capa generosa sobre los labios antes de acostarse.',
    keyIngredients: [
      { name: 'Manteca de Karité Pura', desc: 'Nutre intensamente y regenera la piel agrietada.' },
      { name: 'Péptidos Voluminizadores', desc: 'Estimulan la producción de colágeno en la zona peribucal.' },
      { name: 'Extracto de Frutos Rojos', desc: 'Antioxidantes que protegen y aportan un aroma 100% natural.' }
    ]
  }
};

// ==========================================================================
// CART STATE & CORE ENGINE
// ==========================================================================
let CAMO_LIVE_CART = {
  item_count: 0,
  subtotal_html: '0,00 €',
  items: []
};

let CAMO_WISHLIST = [];
try {
  const savedW = localStorage.getItem('camo_wishlist_v1');
  if (savedW) CAMO_WISHLIST = JSON.parse(savedW);
} catch (e) {
  CAMO_WISHLIST = [];
}

try {
  const savedCart = localStorage.getItem('CAMO_LOCAL_CART_V2');
  if (savedCart) {
    CAMO_LIVE_CART = JSON.parse(savedCart);
  }
} catch (e) {
  CAMO_LIVE_CART = { item_count: 0, subtotal_html: '0,00 €', items: [] };
}

// ==========================================================================
// ZERO-LATENCY INSTANT CART & SYNC ENGINE (SHOPIFY + WC + STANDALONE)
// ==========================================================================

function camoFormatMoney(centsOrEuros) {
  let val = typeof centsOrEuros === 'number' ? centsOrEuros : parseFloat(centsOrEuros);
  if (isNaN(val)) val = 0;
  if (val >= 500 && Number.isInteger(val)) {
    val = val / 100;
  }
  return val.toFixed(2).replace('.', ',') + ' €';
}

function camoShowToast(message) {
  const toast = document.getElementById('toastMessage') || document.querySelector('.toast-message') || document.querySelector('.toast-notification');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  setTimeout(() => toast.classList.remove('is-visible'), 3200);
}

function camoOpenCartDrawer() {
  const backdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop') || document.querySelector('.drawer-backdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  const drawer = document.getElementById('cartDrawer') || (backdrop ? backdrop.querySelector('.cart-drawer') : null);
  if (drawer) {
    drawer.style.setProperty('transform', 'translateX(0)', 'important');
  }
  camoRenderCart();
}

function camoCloseCartDrawer() {
  const backdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop') || document.querySelector('.drawer-backdrop');
  const drawer = document.getElementById('cartDrawer') || (backdrop ? backdrop.querySelector('.cart-drawer') : null);
  if (drawer) {
    drawer.style.setProperty('transform', 'translateX(100%)', 'important');
  }
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.setProperty('opacity', '0', 'important');
    backdrop.style.setProperty('visibility', 'hidden', 'important');
    backdrop.style.setProperty('pointer-events', 'none', 'important');
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}

function camoOpenWishlistDrawer() {
  const backdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  camoRenderWishlist();
}

function camoCloseWishlistDrawer() {
  const backdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.setProperty('opacity', '0', 'important');
    backdrop.style.setProperty('visibility', 'hidden', 'important');
    backdrop.style.setProperty('pointer-events', 'none', 'important');
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}


// Product handle to Shopify / WooCommerce mapping
const CAMO_HANDLE_MAP = {
  'camo-calm-mist': ['camo-calm-barrier-defense-mist', 'camo-calm-mist', 'barrier-defense-mist', 'bruma-facial-camo-calm'],
  'camo_calm_mist': ['camo-calm-barrier-defense-mist', 'camo-calm-mist', 'barrier-defense-mist', 'bruma-facial-camo-calm'],
  'camo-calm-barrier-defense-mist': ['camo-calm-barrier-defense-mist', 'camo-calm-mist'],
  
  'camo-calm-serum': ['bioactive-prebiotics-jelly-serum', 'camo-calm-serum', 'camo-calm-prebiotics-serum', 'bioactive-prebiotics-serum', 'jelly-serum', 'serum-camo-calm'],
  'camo_calm_serum': ['bioactive-prebiotics-jelly-serum', 'camo-calm-serum', 'camo-calm-prebiotics-serum', 'bioactive-prebiotics-serum', 'jelly-serum', 'serum-camo-calm'],
  'bioactive-prebiotics-jelly-serum': ['bioactive-prebiotics-jelly-serum', 'camo-calm-serum', 'camo-calm-prebiotics-serum'],
  'bioactive_prebiotics_jelly_serum': ['bioactive-prebiotics-jelly-serum', 'camo-calm-serum', 'camo-calm-prebiotics-serum'],
  
  'niacinamide': ['niacinamide-gel-moisturiser', 'niacinamide', 'niacinamide-5-gel-moisturiser', 'camo-hydra-cream', 'gel-hidratante-niacinamida'],
  'niacinamide-gel-moisturiser': ['niacinamide-gel-moisturiser', 'niacinamide', 'niacinamide-5-gel-moisturiser'],
  'niacinamide_gel_moisturiser': ['niacinamide-gel-moisturiser', 'niacinamide', 'niacinamide-5-gel-moisturiser'],
  'camo-hydra-cream': ['niacinamide-gel-moisturiser', 'niacinamide'],
  
  'reti-glow': ['reti-glow-serum-oil', 'reti-glow', 'camo-renew-elixir', 'aceite-facial-reti-glow'],
  'reti_glow': ['reti-glow-serum-oil', 'reti-glow', 'camo-renew-elixir'],
  'reti-glow-serum-oil': ['reti-glow-serum-oil', 'reti-glow'],
  
  'peeling-enzimatico': ['peeling-enzimatico', 'peeling-enzimatico-suave', 'peeling-facial-enzimatico'],
  'peeling_enzimatico': ['peeling-enzimatico', 'peeling-enzimatico-suave'],
  
  'purifying-mousse': ['purifying-mousse-cleanser', 'purifying-mousse', 'mousse-limpiadora-purificante', 'mousse-purificante'],
  'purifying_mousse': ['purifying-mousse-cleanser', 'purifying-mousse'],
  'purifying-mousse-cleanser': ['purifying-mousse-cleanser', 'purifying-mousse'],
  
  'lip-mask': ['lip-treatment-mask', 'lip-mask', 'mascarilla-labial-reparadora', 'lip-treatment'],
  'lip_mask': ['lip-treatment-mask', 'lip-mask'],
  'lip-treatment-mask': ['lip-treatment-mask', 'lip-mask']
};

window.__camoShopifyVariantCache = window.__camoShopifyVariantCache || {};

// Preload Shopify variant IDs in the background on page load
async function camoPreloadShopifyVariants() {
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    const res = await fetch(rootPath + 'products.json?limit=50', { headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      const data = await res.json();
      if (data && Array.isArray(data.products)) {
        data.products.forEach(p => {
          if (p.variants && p.variants.length > 0) {
            const vId = p.variants[0].id;
            if (p.handle) window.__camoShopifyVariantCache[p.handle] = vId;
            if (p.id) window.__camoShopifyVariantCache[String(p.id)] = vId;
            if (p.title) {
              const normTitle = p.title.toLowerCase().replace(/[^a-z0-9]/g, '');
              window.__camoShopifyVariantCache[normTitle] = vId;
            }
          }
        });
      }
    }
  } catch (e) {}
}

// Safely resolve the exact Shopify Variant ID for a specific product
async function camoGetShopifyVariantId(productIdentifier, handle, title, elemOrCard) {
  // 1. If productIdentifier is directly a numeric Shopify variant ID (>= 8 digits)
  if (typeof productIdentifier === 'number' && productIdentifier > 10000000) return productIdentifier;
  if (typeof productIdentifier === 'string' && /^\d{8,}$/.test(productIdentifier.trim())) {
    return parseInt(productIdentifier.trim(), 10);
  }

  // 2. Build list of potential handle candidates
  const candidates = [];
  if (handle) candidates.push(handle);
  const rawId = String(productIdentifier || '').trim();
  if (rawId) candidates.push(rawId);
  const normKey = rawId.toLowerCase().replace(/_/g, '-');
  if (normKey && !candidates.includes(normKey)) candidates.push(normKey);

  const mapped = CAMO_HANDLE_MAP[rawId] || CAMO_HANDLE_MAP[normKey];
  if (mapped && Array.isArray(mapped)) {
    mapped.forEach(h => { if (!candidates.includes(h)) candidates.push(h); });
  }

  // 3. Check memory cache
  for (let c of candidates) {
    if (window.__camoShopifyVariantCache[c]) return window.__camoShopifyVariantCache[c];
  }
  if (title) {
    const normT = title.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (window.__camoShopifyVariantCache[normT]) return window.__camoShopifyVariantCache[normT];
  }

  // 4. Check DOM for matching card/element ONLY
  if (elemOrCard && elemOrCard.getAttribute) {
    const directVid = elemOrCard.getAttribute('data-variant-id');
    if (directVid && /^\d{8,}$/.test(String(directVid).trim())) {
      const parsed = parseInt(String(directVid).trim(), 10);
      if (handle) window.__camoShopifyVariantCache[handle] = parsed;
      return parsed;
    }
  }

  for (let c of candidates) {
    const domCard = document.querySelector(`[data-product-handle="${c}"], [data-handle="${c}"], [data-product-id="${c}"], [data-slug="${c}"]`);
    if (domCard) {
      const vId = domCard.getAttribute('data-variant-id') || 
                  (domCard.querySelector('input[name="id"]') ? domCard.querySelector('input[name="id"]').value : null);
      if (vId && /^\d{8,}$/.test(String(vId).trim())) {
        const parsed = parseInt(String(vId).trim(), 10);
        window.__camoShopifyVariantCache[c] = parsed;
        return parsed;
      }
    }
  }

  // 5. If we are on the single product page of THIS specific product
  if (typeof window !== 'undefined' && window.location && window.location.pathname.includes('/products/')) {
    const currentUrlHandle = window.location.pathname.split('/products/')[1]?.split('?')[0]?.replace(/\/$/, '');
    if (currentUrlHandle && candidates.includes(currentUrlHandle)) {
      const singleFormInput = document.querySelector('form[action*="/cart/add"] input[name="id"], #camoProductForm input[name="id"]');
      if (singleFormInput && singleFormInput.value && /^\d{8,}$/.test(singleFormInput.value.trim())) {
        const parsed = parseInt(singleFormInput.value.trim(), 10);
        window.__camoShopifyVariantCache[currentUrlHandle] = parsed;
        return parsed;
      }
    }
  }

  // 6. Asynchronous fetch to Shopify's /products/${candidate}.js
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  for (let c of candidates) {
    try {
      const res = await fetch(rootPath + 'products/' + encodeURIComponent(c) + '.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.variants && data.variants.length > 0) {
          const vId = data.variants[0].id;
          window.__camoShopifyVariantCache[c] = vId;
          if (data.handle) window.__camoShopifyVariantCache[data.handle] = vId;
          return vId;
        }
      }
    } catch (e) {}
  }

  // 7. Search API fallback
  if (title || rawId) {
    try {
      const query = encodeURIComponent(title || rawId);
      const sRes = await fetch(rootPath + 'search/suggest.json?q=' + query + '&resources[type]=product&resources[options][fields]=title,handle', {
        headers: { 'Accept': 'application/json' }
      });
      if (sRes.ok) {
        const sData = await sRes.json();
        const prods = sData?.resources?.results?.products;
        if (prods && prods.length > 0 && prods[0].handle) {
          const pRes = await fetch(rootPath + 'products/' + prods[0].handle + '.js');
          if (pRes.ok) {
            const pData = await pRes.json();
            if (pData?.variants?.[0]?.id) {
              const vId = pData.variants[0].id;
              window.__camoShopifyVariantCache[prods[0].handle] = vId;
              return vId;
            }
          }
        }
      }
    } catch (e) {}
  }

  return null;
}


// 1. Fetch Cart (WooCommerce / Shopify / LocalStorage)
async function camoFetchLiveCart(openDrawerAfter = false) {
  // A. Check WordPress / WooCommerce
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_get_cart_data');
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      const wpRes = await fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
      const wpData = await wpRes.json();
      if (wpData && wpData.success && wpData.data) {
        CAMO_LIVE_CART = wpData.data;
        camoRenderCart();
        if (openDrawerAfter) camoOpenCartDrawer();
        return;
      }
    } catch (e) {}
  }

  // B. Check Shopify AJAX API
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    const res = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      const data = await res.json();
      if (data && typeof data.item_count === 'number') {
        const mappedItems = (data.items || []).map(item => ({
          key: String(item.key || item.id),
          id: item.id,
          handle: item.handle || '',
          name: item.product_title || item.title,
          variant_title: item.variant_title || '',
          price: item.price ? item.price / 100 : 0,
          price_html: camoFormatMoney(item.line_price),
          unit_price_html: camoFormatMoney(item.price),
          quantity: item.quantity,
          image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_reti_glow.png')),
          url: item.url || '#'
        }));

        if (mappedItems.length > 0) {
          CAMO_LIVE_CART = {
            item_count: data.item_count || 0,
            subtotal_html: camoFormatMoney(data.total_price),
            items: mappedItems
          };
        } else {
          try {
            const saved = localStorage.getItem('CAMO_LOCAL_CART_V2');
            if (saved) {
              const parsed = JSON.parse(saved);
              if (parsed && parsed.items && parsed.items.length > 0) {
                CAMO_LIVE_CART = parsed;
              }
            }
          } catch (e) {}
        }

        camoRenderCart();
        if (openDrawerAfter) camoOpenCartDrawer();
        return;
      }
    }
  } catch (err) {}

  // C. Fallback: LocalStorage Cart
  try {
    const saved = localStorage.getItem('CAMO_LOCAL_CART_V2');
    if (saved) {
      CAMO_LIVE_CART = JSON.parse(saved);
    }
  } catch (e) {}

  camoRenderCart();
  if (openDrawerAfter) camoOpenCartDrawer();
}

// 2. Add To Cart (Instant Reactive Update + Asynchronous Backend Sync)
async function camoAddToCart(productIdentifier, quantity = 1, showDrawer = true, extraMeta = {}) {
  quantity = parseInt(quantity) || 1;
  if (quantity < 1) quantity = 1;

  let elem = null;
  let card = null;

  // 1. Resolve DOM Element & Dataset Attributes
  if (productIdentifier && (productIdentifier instanceof HTMLElement || productIdentifier.nodeType === 1)) {
    elem = productIdentifier;
    card = elem.closest('.product-card, .camo-single-product-wrapper, .camo-grid-product-card, .product-item, [data-variant-id], [data-product-id], [data-product-handle]') || elem.closest('form, article, li, div') || elem;
    
    const vId = (elem && (elem.getAttribute('data-variant-id') || elem.getAttribute('data-product-id') || elem.getAttribute('data-product_id') || elem.getAttribute('data-id'))) ||
                (card && (card.getAttribute('data-variant-id') || card.getAttribute('data-product-id') || card.getAttribute('data-product_id') || card.getAttribute('data-id')));
                
    const hnd = (elem && (elem.getAttribute('data-product-handle') || elem.getAttribute('data-handle') || elem.getAttribute('data-slug'))) ||
                (card && (card.getAttribute('data-product-handle') || card.getAttribute('data-handle') || card.getAttribute('data-slug'))) ||
                (card && card.querySelector('a[href*="/products/"]') ? card.querySelector('a[href*="/products/"]').getAttribute('href').split('/products/')[1]?.split('?')[0] : null);
                
    const tit = (elem && (elem.getAttribute('data-product-title') || elem.getAttribute('data-title'))) ||
                (card && (card.getAttribute('data-product-title') || card.getAttribute('data-title'))) ||
                (card && card.querySelector('.product-name, .camo-card-title, h1, h2, h3') ? card.querySelector('.product-name, .camo-card-title, h1, h2, h3').textContent.trim() : null) ||
                (document.querySelector('.product-title, h1.product-name, .camo-product-sticky-info h1') ? document.querySelector('.product-title, h1.product-name, .camo-product-sticky-info h1').textContent.trim() : null);
                
    const prc = (elem && (elem.getAttribute('data-product-price') || elem.getAttribute('data-price'))) ||
                (card && (card.getAttribute('data-product-price') || card.getAttribute('data-price'))) ||
                (card && card.querySelector('.product-price, .camo-card-price, .price') ? card.querySelector('.product-price, .camo-card-price, .price').textContent.trim() : null);
                
    const img = (elem && (elem.getAttribute('data-product-image') || elem.getAttribute('data-image'))) ||
                (card && (card.getAttribute('data-product-image') || card.getAttribute('data-image'))) ||
                (card && card.querySelector('.product-image, img') ? card.querySelector('.product-image, img').src : null);

    const resolvedUrl = (card && card.querySelector('a[href*="/products/"]') ? card.querySelector('a[href*="/products/"]').getAttribute('href') : null) || (hnd ? ('/products/' + hnd) : null);
                
    productIdentifier = vId || hnd || '';
    extraMeta = { title: tit, price: prc, image: img, handle: hnd, variantId: vId, url: resolvedUrl };
  } else if (productIdentifier && typeof productIdentifier === 'object') {
    if (!extraMeta || Object.keys(extraMeta).length === 0) {
      extraMeta = productIdentifier;
    }
    productIdentifier = productIdentifier.variantId || productIdentifier.variant_id || productIdentifier.id || productIdentifier.handle || productIdentifier.slug || '';
  }

  const rawIdStr = String(productIdentifier || '').trim();
  const normalizedKey = rawIdStr.toLowerCase().replace(/_/g, '-');
  let localProduct = null;
  const isWooCommerce = (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url);
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));

  // Comprehensive Product Aliases Map
  const ID_ALIASES = {
    'camo_calm_mist': 'camo-calm-mist',
    'camo-calm-mist': 'camo-calm-mist',
    'camo-calm-barrier-defense-mist': 'camo-calm-mist',
    'barrier-defense-mist': 'camo-calm-mist',
    'mist': 'camo-calm-mist',
    
    'camo_calm_serum': 'camo-calm-serum',
    'camo-calm-serum': 'camo-calm-serum',
    'bioactive-prebiotics-jelly-serum': 'camo-calm-serum',
    'bioactive_prebiotics_jelly_serum': 'camo-calm-serum',
    'jelly-serum': 'camo-calm-serum',
    'camo-calm-prebiotics-serum': 'camo-calm-serum',
    
    'niacinamide': 'niacinamide',
    'niacinamide-gel-moisturiser': 'niacinamide',
    'niacinamide_gel_moisturiser': 'niacinamide',
    'camo_hydra_cream': 'niacinamide',
    'camo-hydra-cream': 'niacinamide',
    'gel-moisturiser': 'niacinamide',
    
    'reti-glow': 'reti-glow',
    'reti_glow': 'reti-glow',
    'reti-glow-serum-oil': 'reti-glow',
    'camo_renew_elixir': 'reti-glow',
    'camo-renew-elixir': 'reti-glow',
    'bakuchiol': 'reti-glow',

    'peeling-enzimatico': 'peeling-enzimatico',
    'peeling_enzimatico': 'peeling-enzimatico',
    'purifying-mousse': 'purifying-mousse',
    'purifying_mousse': 'purifying-mousse',
    'lip-mask': 'lip-mask',
    'lip_mask': 'lip-mask'
  };

  const resolvedAlias = ID_ALIASES[rawIdStr] || ID_ALIASES[normalizedKey];

  // Look up product in catalog
  if (resolvedAlias && CAMO_PRODUCTS[resolvedAlias]) {
    localProduct = CAMO_PRODUCTS[resolvedAlias];
  } else if (CAMO_PRODUCTS[rawIdStr]) {
    localProduct = CAMO_PRODUCTS[rawIdStr];
  } else if (CAMO_PRODUCTS[normalizedKey]) {
    localProduct = CAMO_PRODUCTS[normalizedKey];
  } else {
    for (let k in CAMO_PRODUCTS) {
      const p = CAMO_PRODUCTS[k];
      if (p.id === rawIdStr || 
          p.id === normalizedKey ||
          (p.slug && (p.slug === rawIdStr || p.slug === normalizedKey)) ||
          String(p.wc_id) === rawIdStr || 
          (p.name && p.name.toLowerCase() === rawIdStr.toLowerCase()) ||
          normalizedKey.includes(k) ||
          k.includes(normalizedKey)) {
        localProduct = p;
        break;
      }
    }
  }

  // Determine Product Display Info
  let itemTitle = (extraMeta && extraMeta.title) || (localProduct && localProduct.name);
  let itemPrice = (extraMeta && typeof extraMeta.price === 'number' ? extraMeta.price : null) || (localProduct && localProduct.price);
  let itemImage = (extraMeta && extraMeta.image) || (localProduct && localProduct.image);

  if (!itemTitle) {
    const pageTitle = (card ? card.querySelector('.product-name, h1, h2, h3, .camo-card-title') : null) || document.querySelector('.camo-product-sticky-info h1, .product-title, h1.product-name');
    if (pageTitle) itemTitle = pageTitle.textContent.trim();
  }
  if (!itemTitle) itemTitle = (localProduct && localProduct.name) || 'Tratamiento Botánico CAMO';

  if (!itemPrice) {
    const pagePrice = (extraMeta && extraMeta.price) || (card ? card.querySelector('.product-price, .camo-card-price, .price') : null) || document.querySelector('.camo-product-sticky-info .product-price, .product-price');
    if (pagePrice) {
      const strP = typeof pagePrice === 'string' ? pagePrice : (pagePrice.textContent || '30');
      itemPrice = parseFloat(strP.replace(',', '.').replace(/[^0-9.]/g, '')) || 30.00;
    } else {
      itemPrice = 30.00;
    }
  }

  if (!itemImage) {
    const pageImg = (card ? card.querySelector('.product-image, img, .camo-vertical-img') : null) || document.querySelector('.camo-vertical-img, .product-image');
    itemImage = pageImg ? pageImg.src : (localProduct && localProduct.image) || camoGetAssetUrl('product_camo_calm_serum.png');
  }

  // =========================================================================
  // STEP 1: INSTANT REACTIVE CLIENT-SIDE UPDATE (0ms LATENCY GUARANTEED)
  // =========================================================================
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];

  const itemId = (extraMeta && (extraMeta.variantId || extraMeta.id)) || (localProduct && localProduct.id) || resolvedAlias || rawIdStr || ('prod-' + Date.now());
  const existing = CAMO_LIVE_CART.items.find(i => String(i.id) === String(itemId) || String(i.key) === String(itemId) || (itemTitle && i.name && i.name.toLowerCase() === itemTitle.toLowerCase()));
  
  if (existing) {
    existing.quantity += quantity;
    const unitP = typeof existing.price === 'number' ? existing.price : itemPrice;
    existing.price_html = camoFormatMoney(existing.quantity * unitP);
  } else {
    const resolvedItemUrl = (extraMeta && extraMeta.url) || 
                            (localProduct && ('/products/' + (localProduct.slug || localProduct.id))) ||
                            (typeof window !== 'undefined' && window.location.pathname.includes('/products/') ? window.location.pathname : null) ||
                            (extraMeta && extraMeta.handle ? ('/products/' + extraMeta.handle) : '/collections/all');

    CAMO_LIVE_CART.items.push({
      key: String(itemId),
      id: itemId,
      name: itemTitle,
      price: itemPrice,
      unit_price_html: camoFormatMoney(itemPrice),
      price_html: camoFormatMoney(itemPrice * quantity),
      quantity: quantity,
      image: itemImage,
      url: resolvedItemUrl,
      handle: (extraMeta && extraMeta.handle) || (localProduct && localProduct.slug) || ''
    });
  }

  // Recalculate Totals
  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : (parseFloat(String(it.unit_price_html || it.price_html || '').replace(',', '.').replace(/[^0-9.]/g, '')) || itemPrice);
    totalPrice += p * it.quantity;
  });

  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);

  try {
    localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART));
  } catch (e) {}

  // RENDER & OPEN IMMEDIATELY
  camoRenderCart();
  camoShowToast('✓ Producto añadido a tu cesta');
  if (showDrawer) {
    camoOpenCartDrawer();
  }

  // =========================================================================
  // STEP 2: ASYNCHRONOUS BACKEND SYNC (SHOPIFY / WOOCOMMERCE)
  // =========================================================================
  
  // A. SHOPIFY BACKEND SYNC
  if (isShopify) {
    const handle = (extraMeta && extraMeta.handle) || (localProduct && localProduct.slug) || rawIdStr;
    const shopifyVariantId = await camoGetShopifyVariantId(productIdentifier, handle, itemTitle, elem || card);

    if (shopifyVariantId && shopifyVariantId > 0) {
      const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: shopifyVariantId,
              quantity: quantity
            }]
          })
        });
        if (sRes.ok) {
          fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(data => {
              if (data && data.items && data.items.length > 0) {
                CAMO_LIVE_CART = {
                  item_count: data.item_count,
                  subtotal_html: camoFormatMoney(data.total_price),
                  items: data.items.map(item => ({
                    key: String(item.key || item.id),
                    id: item.id,
                    name: item.product_title || item.title,
                    price: item.price ? item.price / 100 : 0,
                    price_html: camoFormatMoney(item.line_price),
                    unit_price_html: camoFormatMoney(item.price),
                    quantity: item.quantity,
                    image: item.image || camoGetAssetUrl('product_camo_calm_serum.png'),
                    url: item.url || '#'
                  }))
                };
                camoRenderCart();
              }
            }).catch(() => {});
        }
      } catch (e) {}
    }
  }

  // B. WOOCOMMERCE BACKEND SYNC
  if (isWooCommerce) {
    let wcId = (localProduct && localProduct.wc_id) || (!isNaN(parseInt(rawIdStr)) ? parseInt(rawIdStr) : 0);
    if (wcId > 0) {
      try {
        const formData = new FormData();
        formData.append('action', 'camo_add_to_cart');
        formData.append('product_id', wcId);
        formData.append('quantity', quantity);
        if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
        fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
      } catch (e) {}
    }
  }
}

// 3. Update Cart Quantity
async function camoUpdateCartItemQty(keyOrId, newQty) {
  newQty = parseInt(newQty) || 0;
  if (newQty <= 0) {
    return camoRemoveCartItem(keyOrId);
  }

  // Update in local cart immediately
  if (CAMO_LIVE_CART.items) {
    const it = CAMO_LIVE_CART.items.find(i => i.key == keyOrId || i.id == keyOrId);
    if (it) {
      it.quantity = newQty;
      const p = typeof it.price === 'number' ? it.price : 30;
      it.price_html = camoFormatMoney(p * newQty);
    }
    let totalCount = 0;
    let totalPrice = 0;
    CAMO_LIVE_CART.items.forEach(i => {
      totalCount += i.quantity;
      const p = typeof i.price === 'number' ? i.price : 30;
      totalPrice += p * i.quantity;
    });
    CAMO_LIVE_CART.item_count = totalCount;
    CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);
    try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
    camoRenderCart();
  }

  // Backend sync Shopify
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(keyOrId), quantity: newQty })
    });
  } catch (e) {}

  // Backend sync WordPress
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_update_cart_qty');
      formData.append('cart_item_key', keyOrId);
      formData.append('quantity', newQty);
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
    } catch (e) {}
  }
}

// 4. Remove Cart Item
async function camoRemoveCartItem(keyOrId) {
  if (CAMO_LIVE_CART.items) {
    CAMO_LIVE_CART.items = CAMO_LIVE_CART.items.filter(i => i.key != keyOrId && i.id != keyOrId);
    let totalCount = 0;
    let totalPrice = 0;
    CAMO_LIVE_CART.items.forEach(i => {
      totalCount += i.quantity;
      const p = typeof i.price === 'number' ? i.price : 30;
      totalPrice += p * i.quantity;
    });
    CAMO_LIVE_CART.item_count = totalCount;
    CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);
    try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
    camoRenderCart();
    camoShowToast('✓ Producto eliminado de la cesta');
  }

  // Backend sync Shopify
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(keyOrId), quantity: 0 })
    });
  } catch (e) {}

  // Backend sync WordPress
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_remove_cart_item');
      formData.append('cart_item_key', keyOrId);
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
    } catch (e) {}
  }
}

// 5. Render Cart Drawer
function camoRenderCart() {
  const countBadges = document.querySelectorAll('.cart-count-badge');
  countBadges.forEach(b => b.textContent = CAMO_LIVE_CART.item_count || 0);

  const countEls = document.querySelectorAll('#cartItemCount, .cart-item-count');
  countEls.forEach(el => el.textContent = `${CAMO_LIVE_CART.item_count || 0} producto${CAMO_LIVE_CART.item_count === 1 ? '' : 's'}`);

  const subtotalEls = document.querySelectorAll('#cartSubtotal, #cartTotal, .cart-subtotal-val');
  subtotalEls.forEach(el => el.innerHTML = CAMO_LIVE_CART.subtotal_html || '0,00 €');

  const shippingText = document.getElementById('shippingMeterText');
  const shippingBar = document.getElementById('shippingProgressBar');
  if (shippingText || shippingBar) {
    let rawTotal = 0;
    if (CAMO_LIVE_CART.items && CAMO_LIVE_CART.items.length) {
      CAMO_LIVE_CART.items.forEach(it => {
        const p = typeof it.price === 'number' ? it.price : parseFloat(String(it.unit_price_html || it.price_html || '').replace(',', '.').replace(/[^0-9.]/g, '')) || 0;
        rawTotal += p * (it.quantity || 1);
      });
    }
    const freeThreshold = 45.00;
    const pct = Math.min(100, Math.round((rawTotal / freeThreshold) * 100));
    if (shippingBar) shippingBar.style.width = pct + '%';
    if (shippingText) {
      if (rawTotal >= freeThreshold) {
        shippingText.innerHTML = '✨ ¡Felicidades! Tienes <strong>Envío Gratis</strong> garantizado';
      } else {
        const diff = (freeThreshold - rawTotal).toFixed(2).replace('.', ',');
        shippingText.innerHTML = `Añade <strong>${diff} €</strong> más para <strong>Envío Gratis</strong>`;
      }
    }
  }

  const containers = document.querySelectorAll('#cartItemsList, #cartDrawerItems, .cart-items-list');
  const emptyStates = document.querySelectorAll('#cartEmptyState, .cart-empty-state');

  if (!CAMO_LIVE_CART.items || CAMO_LIVE_CART.items.length === 0) {
    emptyStates.forEach(es => es.style.setProperty('display', 'block', 'important'));
    containers.forEach(c => c.innerHTML = '');
    return;
  }

  emptyStates.forEach(es => es.style.setProperty('display', 'none', 'important'));

  const itemsHtml = CAMO_LIVE_CART.items.map(item => {
    const itemLink = item.url && item.url !== '#' ? item.url : (item.handle ? ('/products/' + item.handle) : '/collections/all');
    return `
    <div class="cart-item" style="display:flex; align-items:center; gap:1.15rem; padding:1.1rem 0; border-bottom:1px solid rgba(28,23,24,0.06);">
      <a href="${itemLink}" onclick="window.camoApp.closeCart()" style="flex-shrink:0; display:block;" title="Ver ficha de producto">
        <img src="${item.image || camoGetAssetUrl('product_camo_calm_serum.png')}" alt="${item.name || 'Producto CAMO'}" class="cart-item-thumb" style="width:68px; height:68px; object-fit:contain; background:#FAF7F2; border-radius:12px; padding:0.35rem; border:1px solid rgba(28,23,24,0.05); display:block; cursor:pointer; transition:transform 0.2s;">
      </a>
      <div style="flex:1; min-width:0;">
        <a href="${itemLink}" onclick="window.camoApp.closeCart()" style="text-decoration:none; color:inherit; display:block;" title="Ver ficha de producto">
          <h4 class="cart-item-title" style="font-family:'Plus Jakarta Sans',sans-serif; font-size:0.92rem; font-weight:700; color:#1C1718; margin:0 0 0.2rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; cursor:pointer;">
            ${item.name || 'Producto CAMO'}
          </h4>
        </a>
        <div style="font-size:0.85rem; font-weight:700; color:#C67A63; margin-bottom:0.5rem;">
          ${item.price_html || item.unit_price_html || camoFormatMoney(item.price || 30)}
        </div>
        <div style="display:flex; align-items:center; gap:0.6rem;">
          <div style="display:inline-flex; align-items:center; border:1px solid rgba(28,23,24,0.12); border-radius:50px; background:#FFF;">
            <button type="button" onclick="window.camoApp.updateLiveQty('${item.key || item.id}', ${item.quantity - 1})" style="border:none; background:none; width:26px; height:26px; cursor:pointer; font-weight:700; font-size:0.85rem; color:#1C1718;" aria-label="Restar">-</button>
            <span style="font-size:0.8rem; font-weight:700; min-width:18px; text-align:center;">${item.quantity}</span>
            <button type="button" onclick="window.camoApp.updateLiveQty('${item.key || item.id}', ${item.quantity + 1})" style="border:none; background:none; width:26px; height:26px; cursor:pointer; font-weight:700; font-size:0.85rem; color:#1C1718;" aria-label="Sumar">+</button>
          </div>
          <button type="button" onclick="window.camoApp.removeLiveItem('${item.key || item.id}')" style="border:none; background:none; color:#A09899; font-size:0.75rem; text-decoration:underline; cursor:pointer; padding:0.2rem;">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  `; }).join('');

  containers.forEach(c => c.innerHTML = itemsHtml);
}

// 6. Routine Builder Complete Add (Batch add all selected distinct formulas)
async function camoAddBuiltRoutineToShopify() {
  const cards = document.querySelectorAll('.routine-product-card.is-selected');
  if (!cards.length) {
    camoShowToast('Selecciona al menos un tratamiento para tu ritual');
    return;
  }

  const selectedProducts = [];
  cards.forEach(card => {
    const pid = card.getAttribute('data-product-id') || 'camo-calm-serum';
    const handle = card.getAttribute('data-product-handle') || pid;
    const tit = card.querySelector('h4') ? card.querySelector('h4').textContent.trim() : (CAMO_PRODUCTS[pid]?.name || 'Fórmula Botánica CAMO');
    const prc = parseFloat(card.getAttribute('data-price')) || (CAMO_PRODUCTS[pid]?.price || 30.00);
    const imgEl = card.querySelector('img');
    const img = imgEl ? imgEl.src : (CAMO_PRODUCTS[pid]?.image || camoGetAssetUrl('product_camo_calm_serum.png'));
    const vid = card.getAttribute('data-variant-id');

    selectedProducts.push({
      id: pid,
      handle: handle,
      title: tit,
      price: prc,
      image: img,
      variantId: vid,
      url: '/products/' + handle
    });
  });

  // 1. Instant local cart update with all selected distinct products
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];
  
  selectedProducts.forEach(prod => {
    const existing = CAMO_LIVE_CART.items.find(i => 
      String(i.id) === String(prod.id) || 
      (prod.handle && i.handle === prod.handle) ||
      (prod.title && i.name && i.name.toLowerCase() === prod.title.toLowerCase())
    );
    if (existing) {
      existing.quantity += 1;
      const unitP = typeof existing.price === 'number' ? existing.price : prod.price;
      existing.price_html = camoFormatMoney(existing.quantity * unitP);
    } else {
      CAMO_LIVE_CART.items.push({
        key: String(prod.id),
        id: prod.id,
        name: prod.title,
        price: prod.price,
        unit_price_html: camoFormatMoney(prod.price),
        price_html: camoFormatMoney(prod.price),
        quantity: 1,
        image: prod.image,
        url: prod.url,
        handle: prod.handle
      });
    }
  });

  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : 30;
    totalPrice += p * it.quantity;
  });
  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);

  try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
  camoRenderCart();
  camoShowToast('✨ Ritual personalizado (' + selectedProducts.length + ' fórmulas) añadido a tu cesta (-15% DTO)');
  camoOpenCartDrawer();

  // 2. Shopify Asynchronous Backend Batch Sync
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));
  
  if (isShopify) {
    const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const itemsToAdd = [];

    for (let prod of selectedProducts) {
      const vId = await camoGetShopifyVariantId(prod.id, prod.handle, prod.title);
      if (vId) {
        itemsToAdd.push({ id: vId, quantity: 1 });
      }
    }

    if (itemsToAdd.length > 0) {
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (sRes.ok) {
          const cRes = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cRes.ok) {
            const data = await cRes.json();
            if (data && data.items && data.items.length > 0) {
              CAMO_LIVE_CART = {
                item_count: data.item_count,
                subtotal_html: camoFormatMoney(data.total_price),
                items: data.items.map(item => ({
                  key: String(item.key || item.id),
                  id: item.id,
                  name: item.product_title || item.title,
                  price: item.price ? item.price / 100 : 0,
                  price_html: camoFormatMoney(item.line_price),
                  unit_price_html: camoFormatMoney(item.price),
                  quantity: item.quantity,
                  image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_camo_calm_serum.png')),
                  url: item.url || '#'
                }))
              };
              camoRenderCart();
            }
          }
        }
      } catch (e) {}
    }
  }
}

function camoRenderWishlist() {
  const countBadges = document.querySelectorAll('.wishlist-count-badge');
  countBadges.forEach(b => b.textContent = CAMO_WISHLIST.length);

  const container = document.getElementById('wishlistItemsList') || document.getElementById('wishlistDrawerItems');
  const countEl = document.getElementById('wishlistItemCount');
  if (countEl) countEl.textContent = `${CAMO_WISHLIST.length} producto${CAMO_WISHLIST.length === 1 ? '' : 's'}`;

  if (!container) return;

  if (CAMO_WISHLIST.length === 0) {
    container.innerHTML = `
      <div style="text-align:center; padding:3.5rem 1rem; color:#7A7274;">
        <p style="font-size:0.92rem; margin-bottom:1rem;">Tu lista de deseos está vacía.</p>
        <a href="#productos" onclick="window.camoApp.closeWishlist()" class="btn btn-terracotta btn-sm" style="display:inline-block; text-decoration:none;">Descubrir Fórmulas</a>
      </div>
    `;
    return;
  }

  container.innerHTML = CAMO_WISHLIST.map(id => {
    const product = CAMO_PRODUCTS[id];
    if (!product) return '';
    return `
      <div style="display:flex; align-items:center; gap:1rem; padding:1rem 0; border-bottom:1px solid rgba(28,23,24,0.06);">
        <img src="${product.image}" alt="${product.name}" style="width:68px; height:68px; object-fit:contain; background:#FFF; border-radius:10px; padding:0.3rem;">
        <div style="flex:1;">
          <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:0.88rem; font-weight:600; color:#1C1718;">${product.name}</div>
          <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:0.95rem; font-weight:700; color:#C67A63; margin-top:0.25rem;">${product.price.toFixed(2)} €</div>
          <div style="display:flex; gap:0.5rem; margin-top:0.5rem;">
            <button onclick="window.camoApp.addToCart('${product.id}', 1, true)" class="btn btn-terracotta btn-sm" style="padding:0.35rem 0.85rem; font-size:0.72rem;">Añadir a la Cesta</button>
            <button onclick="window.camoApp.toggleWishlist('${product.id}')" style="border:none; background:none; font-size:0.72rem; color:#A09899; text-decoration:underline; cursor:pointer;">Quitar</button>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function camoToggleWishlist(productId) {
  const idx = CAMO_WISHLIST.indexOf(productId);
  if (idx > -1) {
    CAMO_WISHLIST.splice(idx, 1);
    camoShowToast('✓ Eliminado de tu lista de deseos');
  } else {
    CAMO_WISHLIST.push(productId);
    camoShowToast('♥ Añadido a tu lista de deseos');
  }
  try {
    localStorage.setItem('camo_wishlist_v1', JSON.stringify(CAMO_WISHLIST));
  } catch (e) {}
  camoRenderWishlist();
}

function camoOpenQuickView(productId) {
  const product = CAMO_PRODUCTS[productId];
  const modal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  const content = document.getElementById('quickViewContent');

  if (!product || !modal || !content) return;

  content.innerHTML = `
    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap:2rem; align-items:start;">
      <div style="background:#FAF7F2; border-radius:18px; padding:1.5rem; text-align:center; border:1px solid rgba(28,23,24,0.05);">
        <img src="${product.image}" alt="${product.name}" style="max-height:280px; width:auto; max-width:100%; object-fit:contain; margin:0 auto; display:block;">
      </div>
      <div>
        <span style="font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:#C67A63; display:block; margin-bottom:0.4rem;">${product.category} · ${product.volume}</span>
        <h2 style="font-family:'Cormorant Garamond', Georgia, serif; font-size:1.75rem; font-weight:600; color:#1C1718; line-height:1.2; margin:0 0 0.5rem;">${product.name}</h2>
        <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:1.4rem; font-weight:700; color:#C67A63; margin-bottom:1rem;">${product.price.toFixed(2)} €</div>
        <p style="font-size:0.85rem; color:#6B6365; line-height:1.6; margin-bottom:1.25rem;">${product.fullDesc}</p>
        
        <div style="margin-bottom:1.5rem;">
          <div style="font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#1C1718; margin-bottom:0.5rem;">Activos Principales:</div>
          <ul style="padding-left:1.1rem; font-size:0.78rem; color:#4A4244; line-height:1.6;">
            ${product.keyIngredients.map(ing => `<li><strong>${ing.name}:</strong> ${ing.desc}</li>`).join('')}
          </ul>
        </div>

        <button onclick="window.camoApp.addToCart('${product.id}', 1, true); window.camoApp.closeQuickView();" class="btn btn-terracotta" style="width:100%; padding:0.9rem 1.5rem; font-size:0.85rem; font-weight:700; text-transform:uppercase; letter-spacing:0.08em;">
          Añadir a la Cesta · ${product.price.toFixed(2)} €
        </button>
      </div>
    </div>
  `;

  modal.style.display = 'flex';
  modal.style.visibility = 'visible';
  modal.style.opacity = '1';
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function camoCloseQuickView() {
  const modal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  if (modal) {
    modal.classList.remove('is-open');
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 300);
    document.body.style.overflow = '';
  }
}

function camoFilterProducts(category, btnEl) {
  const activeCat = (category || 'all').toLowerCase();

  // 1. Sync button active states
  document.querySelectorAll('.filter-tab-btn').forEach(b => {
    const bFilter = (b.getAttribute('data-filter') || '').toLowerCase();
    if (b === btnEl || bFilter === activeCat) {
      b.classList.add('is-active');
    } else {
      b.classList.remove('is-active');
    }
  });

  // 2. Filter product cards
  const cards = document.querySelectorAll('.product-card');
  let visibleCount = 0;

  cards.forEach((card, index) => {
    const cardCat = (card.getAttribute('data-category') || '').toLowerCase();
    const cardLine = (card.getAttribute('data-line') || '').toLowerCase();
    const cardTitle = (card.querySelector('.product-name') ? card.querySelector('.product-name').textContent : '').toLowerCase();
    const cardId = (card.id || '').toLowerCase();

    let matches = false;

    if (activeCat === 'all') {
      matches = true;
    } else if (activeCat === 'renew' || activeCat === 'glow') {
      matches = (cardLine === 'renew' || cardCat === 'renew' || cardCat === 'glow' || 
                 cardTitle.includes('renew') || cardTitle.includes('reti') || cardTitle.includes('bakuchiol') || cardId.includes('reti-glow') || cardId.includes('renew'));
    } else if (activeCat === 'calm') {
      matches = (cardLine === 'calm' || cardCat === 'calm' || 
                 cardTitle.includes('calm') || cardTitle.includes('prebiotic') || cardTitle.includes('ceramide') || cardTitle.includes('bruma') || cardTitle.includes('mist') || cardId.includes('calm'));
    } else if (activeCat === 'hydra') {
      matches = (cardLine === 'hydra' || cardCat === 'hydra' || 
                 cardTitle.includes('hydra') || cardTitle.includes('niacinamide') || cardTitle.includes('hialur') || cardId.includes('niacinamide') || cardId.includes('hydra'));
    } else if (activeCat === 'packs') {
      matches = (cardLine === 'packs' || cardCat === 'packs' || 
                 cardTitle.includes('pack') || cardTitle.includes('duo') || cardTitle.includes('dúo') || cardTitle.includes('set') || cardTitle.includes('ritual') || cardId.includes('pack'));
    } else if (activeCat === 'clean') {
      matches = (cardLine === 'clean' || cardCat === 'clean' || 
                 cardTitle.includes('peeling') || cardTitle.includes('mousse') || cardTitle.includes('lip') || cardId.includes('peeling') || cardId.includes('mousse') || cardId.includes('lip'));
    }

    if (matches) {
      card.style.display = 'flex';
      card.classList.remove('is-hidden');
      visibleCount++;
    } else {
      card.style.display = 'none';
      card.classList.add('is-hidden');
    }
  });

  if (activeCat === 'all' && document.getElementById('featuredProductsGrid')) {
    let heroCount = 0;
    cards.forEach(c => {
      heroCount++;
      if (heroCount <= 4) {
        c.style.display = 'flex';
      } else {
        c.style.display = 'none';
      }
    });
  }
}

// Live Camera & Scanner
let camoMediaStream = null;

async function camoStartLiveCamera() {
  const scanVideo = document.getElementById('skinaiVideo');
  const scanImage = document.getElementById('skinaiImage');

  try {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      camoMediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } }
      });
      if (scanVideo) {
        scanVideo.srcObject = camoMediaStream;
        scanVideo.setAttribute('playsinline', '');
        scanVideo.setAttribute('autoplay', '');
        scanVideo.setAttribute('muted', '');
        scanVideo.style.display = 'block';
        if (scanImage) scanImage.style.display = 'none';
        scanVideo.play();
      }
      camoTriggerScanSequence('Cámara en vivo');
    } else {
      camoTriggerFallbackScan('Simulación Biométrica');
    }
  } catch (err) {
    console.warn('Camera access denied or unavailable. Fallback to model portrait.', err);
    camoTriggerFallbackScan('Análisis de Fotografía');
  }
}

function camoTriggerFallbackScan(modeName) {
  const scanVideo = document.getElementById('skinaiVideo');
  const scanImage = document.getElementById('skinaiImage');
  if (scanVideo) scanVideo.style.display = 'none';
  if (scanImage) {
    scanImage.style.display = 'block';
    scanImage.src = camoGetAssetUrl('camo_model_glow.jpg');
  }
  camoTriggerScanSequence(modeName);
}

function camoTriggerScanSequence(modeLabel) {
  const scannerCard = document.getElementById('scannerCard');
  const statusText = document.getElementById('scanStatusText');
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');

  if (!scannerCard) return;

  scannerCard.classList.add('is-scanning');
  if (diagnosticResultOverlay) diagnosticResultOverlay.style.display = 'none';

  const steps = [
    { text: `⚡ Calibrando sensor óptico (${modeLabel})...`, duration: 900 },
    { text: '🔍 Mapeando 68 puntos biométricos faciales...', duration: 1100 },
    { text: '💧 Analizando nivel de deshidratación y micro-textura...', duration: 1100 },
    { text: '🌿 Evaluando reactividad, tono y barrera cutánea...', duration: 1000 },
    { text: '✨ Formulando diagnóstico botánico a medida...', duration: 900 }
  ];

  let currentStep = 0;

  function nextStep() {
    if (currentStep < steps.length) {
      if (statusText) statusText.textContent = steps[currentStep].text;
      setTimeout(() => {
        currentStep++;
        nextStep();
      }, steps[currentStep].duration);
    } else {
      camoFinishScan();
    }
  }

  nextStep();
}

function camoFinishScan() {
  const scannerCard = document.getElementById('scannerCard');
  const statusText = document.getElementById('scanStatusText');
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');

  if (scannerCard) scannerCard.classList.remove('is-scanning');
  if (statusText) statusText.textContent = '✓ Diagnóstico completado';

  if (diagnosticResultOverlay) {
    diagnosticResultOverlay.style.display = 'block';
    diagnosticResultOverlay.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  camoShowToast('✨ Lectura de piel completada: Ritual Recomendado Listo');
}


// SkinAI Helpers & Quiz Handlers
let camoQuizState = { step1: 'calm', step2: 'dry', step3: 'complete' };

function camoSelectQuizOption(step, choice) {
  if (step === 1) camoQuizState.step1 = choice;
  if (step === 2) camoQuizState.step2 = choice;
  if (step === 3) camoQuizState.step3 = choice;

  // Update progress bars
  for (let i = 1; i <= 4; i++) {
    const bar = document.getElementById('quizBar' + i);
    if (bar) {
      bar.style.background = i <= (step + 1) ? '#C67A63' : 'rgba(28,23,24,0.1)';
    }
  }

  // Switch step views
  const currentPane = document.getElementById('quizStep' + step);
  const nextPane = document.getElementById('quizStep' + (step + 1));
  if (currentPane) currentPane.style.display = 'none';
  if (nextPane) nextPane.style.display = 'block';
}

// SkinAI Complete Ritual Add (Batch add all 3 distinct recommended formulas)
async function camoAddSkinAIRitualToCart() {
  const ritualProducts = [
    {
      id: 'camo-calm-mist',
      handle: 'camo-calm-barrier-defense-mist',
      title: 'CAMO CALM Barrier Defense Mist (100ml)',
      price: 27.00,
      image: camoGetAssetUrl('product_camo_calm_mist.png'),
      url: '/products/camo-calm-barrier-defense-mist'
    },
    {
      id: 'camo-calm-serum',
      handle: 'bioactive-prebiotics-jelly-serum',
      title: 'Bioactive Prebiotics Jelly Serum (30ml)',
      price: 30.00,
      image: camoGetAssetUrl('product_camo_calm_serum.png'),
      url: '/products/bioactive-prebiotics-jelly-serum'
    },
    {
      id: 'niacinamide',
      handle: 'niacinamide-gel-moisturiser',
      title: 'Niacinamide Gel Moisturiser (50ml)',
      price: 49.00,
      image: camoGetAssetUrl('product_niacinamide_gel.png'),
      url: '/products/niacinamide-gel-moisturiser'
    }
  ];

  // 1. Instant local cart update with all 3 distinct formulas
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];

  ritualProducts.forEach(prod => {
    const existing = CAMO_LIVE_CART.items.find(i => 
      String(i.id) === String(prod.id) || 
      (prod.handle && i.handle === prod.handle) ||
      (prod.title && i.name && i.name.toLowerCase() === prod.title.toLowerCase())
    );
    if (existing) {
      existing.quantity += 1;
      const unitP = typeof existing.price === 'number' ? existing.price : prod.price;
      existing.price_html = camoFormatMoney(existing.quantity * unitP);
    } else {
      CAMO_LIVE_CART.items.push({
        key: String(prod.id),
        id: prod.id,
        name: prod.title,
        price: prod.price,
        unit_price_html: camoFormatMoney(prod.price),
        price_html: camoFormatMoney(prod.price),
        quantity: 1,
        image: prod.image,
        url: prod.url,
        handle: prod.handle
      });
    }
  });

  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : 30;
    totalPrice += p * it.quantity;
  });
  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);

  try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
  camoRenderCart();
  camoShowToast('✨ Ritual SkinAI™ (3 fórmulas) añadido a tu cesta (-15% DTO)');
  camoOpenCartDrawer();
  camoCloseSkinAIModal();

  // 2. Shopify Asynchronous Backend Batch Sync
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));
  
  if (isShopify) {
    const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const itemsToAdd = [];

    for (let prod of ritualProducts) {
      const vId = await camoGetShopifyVariantId(prod.id, prod.handle, prod.title);
      if (vId) {
        itemsToAdd.push({ id: vId, quantity: 1 });
      }
    }

    if (itemsToAdd.length > 0) {
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (sRes.ok) {
          const cRes = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cRes.ok) {
            const data = await cRes.json();
            if (data && data.items && data.items.length > 0) {
              CAMO_LIVE_CART = {
                item_count: data.item_count,
                subtotal_html: camoFormatMoney(data.total_price),
                items: data.items.map(item => ({
                  key: String(item.key || item.id),
                  id: item.id,
                  name: item.product_title || item.title,
                  price: item.price ? item.price / 100 : 0,
                  price_html: camoFormatMoney(item.line_price),
                  unit_price_html: camoFormatMoney(item.price),
                  quantity: item.quantity,
                  image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_camo_calm_serum.png')),
                  url: item.url || '#'
                }))
              };
              camoRenderCart();
            }
          }
        }
      } catch (e) {}
    }
  }
}

function camoResetSkinAIScanner() {
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');
  if (diagnosticResultOverlay) diagnosticResultOverlay.style.display = 'none';
  const statusText = document.getElementById('scanStatusText');
  if (statusText) statusText.textContent = 'Presiona Iniciar Cámara o Diagnóstico';
  camoStartLiveCamera();
}

function camoOpenSkinAIModal() {
  const modal = document.getElementById('skinAiModal') || document.getElementById('skinaiModal');
  if (modal) {
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  } else {
    const sec = document.getElementById('camo-skinai');
    if (sec) sec.scrollIntoView({ behavior: 'smooth' });
  }
}

function camoCloseSkinAIModal() {
  const modal = document.getElementById('skinAiModal') || document.getElementById('skinaiModal');
  if (modal) {
    modal.classList.remove('is-open');
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 300);
    document.body.style.overflow = '';
  }
}

// Hero Slider Functions
function camoGoToHeroSlide(index) {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  const counterNum = document.getElementById('heroCurrentNum');
  if (!slides.length) return;
  heroCurrentIndex = (index + slides.length) % slides.length;

  slides.forEach((slide, i) => {
    if (i === heroCurrentIndex) {
      slide.classList.add('is-active');
      slide.style.opacity = '1';
      slide.style.visibility = 'visible';
      slide.style.transform = 'scale(1)';
    } else {
      slide.classList.remove('is-active');
      slide.style.opacity = '0';
      slide.style.visibility = 'hidden';
      slide.style.transform = 'scale(1.04)';
    }
  });

  dots.forEach((dot, i) => {
    if (i === heroCurrentIndex) {
      dot.classList.add('is-active');
    } else {
      dot.classList.remove('is-active');
    }
  });

  if (counterNum) {
    counterNum.textContent = String(heroCurrentIndex + 1).padStart(2, '0');
  }
  camoResetHeroAutoplay();
}

function camoNextHeroSlide() {
  const slides = document.querySelectorAll('.hero-slide');
  camoGoToHeroSlide(heroCurrentIndex + 1);
}

function camoPrevHeroSlide() {
  const slides = document.querySelectorAll('.hero-slide');
  camoGoToHeroSlide(heroCurrentIndex - 1);
}

function camoResetHeroAutoplay() {
  if (heroAutoplayTimer) clearInterval(heroAutoplayTimer);
  heroAutoplayTimer = setInterval(() => {
    camoNextHeroSlide();
  }, HERO_AUTOPLAY_DELAY);
}

// Reviews Toggle & Filter
let camoReviewsExpanded = false;

function camoToggleMoreReviews() {
  camoReviewsExpanded = !camoReviewsExpanded;
  const extraCards = document.querySelectorAll('.review-extra-card');
  const textEl = document.getElementById('toggleReviewsText');
  const arrowEl = document.getElementById('toggleReviewsArrow');

  extraCards.forEach(card => {
    if (camoReviewsExpanded) {
      card.style.display = 'flex';
      card.style.opacity = '0';
      card.style.transform = 'translateY(12px)';
      setTimeout(() => {
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }, 40);
    } else {
      card.style.display = 'none';
    }
  });

  if (textEl) textEl.textContent = camoReviewsExpanded ? 'Ver menos opiniones' : 'Ver más opiniones de clientas (+4)';
  if (arrowEl) arrowEl.textContent = camoReviewsExpanded ? '▴' : '▾';
}

function camoFilterReviews(type, btn) {
  document.querySelectorAll('.reviews-filter-bar .filter-chip').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');

  const cards = document.querySelectorAll('.reviews-cards-grid .review-card');
  const toggleBtn = document.getElementById('toggleMoreReviewsBtn');

  if (type === 'all') {
    cards.forEach((card, index) => {
      if (index < 2 || camoReviewsExpanded) {
        card.style.display = 'flex';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      } else {
        card.style.display = 'none';
      }
    });
    if (toggleBtn && toggleBtn.parentElement) toggleBtn.parentElement.style.display = 'block';
  } else {
    cards.forEach(card => {
      const cardType = card.getAttribute('data-skin-type');
      if (cardType === type) {
        card.style.display = 'flex';
        card.style.opacity = '0';
        card.style.transform = 'translateY(12px)';
        setTimeout(() => {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 40);
      } else {
        card.style.display = 'none';
      }
    });
    if (toggleBtn && toggleBtn.parentElement) toggleBtn.parentElement.style.display = 'none';
  }
}

// Routine Builder Controls
function camoToggleRoutineCard(cardEl) {
  if (!cardEl) return;
  cardEl.classList.toggle('is-selected');
  camoRecalculateRoutineTotal();
}

function camoRecalculateRoutineTotal() {
  const cards = document.querySelectorAll('.routine-product-card.is-selected');
  let sum = 0;
  cards.forEach(card => {
    sum += parseFloat(card.getAttribute('data-price') || 0);
  });

  const countEl = document.getElementById('routineSelectedCount');
  const oldTotalEl = document.getElementById('routineOldTotal');
  const discountedTotalEl = document.getElementById('routineDiscountedTotal');
  const discountPill = document.getElementById('routineDiscountPill');

  if (countEl) countEl.textContent = cards.length;

  if (cards.length >= 2) {
    const discounted = sum * 0.85;
    if (oldTotalEl) {
      oldTotalEl.style.display = 'inline';
      oldTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    }
    if (discountedTotalEl) discountedTotalEl.textContent = `${discounted.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'inline-flex';
  } else {
    if (oldTotalEl) oldTotalEl.style.display = 'none';
    if (discountedTotalEl) discountedTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'none';
  }
}

function camoToggleAllProductsGrid() {
  const extraCards = document.querySelectorAll('.product-extra-card');
  const textEl = document.getElementById('toggleAllProductsText');
  const arrowEl = document.getElementById('toggleAllProductsArrow');
  let anyHidden = false;

  extraCards.forEach(card => {
    if (card.style.display === 'none' || card.classList.contains('is-hidden')) {
      anyHidden = true;
    }
  });

  if (anyHidden) {
    extraCards.forEach(card => {
      card.style.display = 'flex';
      card.classList.remove('is-hidden');
    });
    if (textEl) textEl.textContent = 'Ver Solo los Favoritos Más Vendidos';
    if (arrowEl) arrowEl.textContent = '▴';
  } else {
    extraCards.forEach(card => {
      card.style.display = 'none';
      card.classList.add('is-hidden');
    });
    if (textEl) textEl.textContent = 'Ver Toda la Colección de Tratamientos (7 Fórmulas)';
    if (arrowEl) arrowEl.textContent = '→';
  }
}

function camoOpenMobileNav() {
  const backdrop = document.getElementById('mobileNavDrawerBackdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
}

function camoCloseMobileNav() {
  const backdrop = document.getElementById('mobileNavDrawerBackdrop');
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.opacity = '';
    backdrop.style.visibility = '';
    backdrop.style.pointerEvents = '';
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}

function camoToggleDesktopDropdown(e) {
  if (e) {
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
  }
  if (typeof window !== 'undefined' && window.innerWidth <= 900) {
    camoOpenMobileNav();
    return;
  }
  const menu = document.getElementById('navDropdownMenu') || document.getElementById('desktopDropdownMenu') || document.querySelector('.nav-dropdown-menu');
  const trigger = document.getElementById('dropdownTriggerBtn') || document.querySelector('.nav-dropdown-trigger');
  if (menu) {
    const willOpen = !menu.classList.contains('is-open');
    menu.classList.toggle('is-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  }
}

// Bind Global window.camoApp object immediately
Object.assign(window.camoApp, {
  getCart: () => CAMO_LIVE_CART,
  fetchLiveCart: camoFetchLiveCart,
  addToCart: camoAddToCart,
  updateLiveQty: camoUpdateCartItemQty,
  removeLiveItem: camoRemoveCartItem,
  openCart: camoOpenCartDrawer,
  closeCart: camoCloseCartDrawer,
  openWishlist: camoOpenWishlistDrawer,
  closeWishlist: camoCloseWishlistDrawer,
  toggleWishlist: camoToggleWishlist,
  openQuickView: camoOpenQuickView,
  closeQuickView: camoCloseQuickView,
  filterProducts: camoFilterProducts,
  startCamera: camoStartLiveCamera,
  startLiveCamera: camoStartLiveCamera,
  resetSkinAIScanner: camoResetSkinAIScanner,
  addSkinAIRitualToCart: camoAddSkinAIRitualToCart,
  selectQuizOption: camoSelectQuizOption,
  openSkinAIModal: camoOpenSkinAIModal,
  closeSkinAIModal: camoCloseSkinAIModal,
  showToast: camoShowToast,
  addBuiltRoutineToShopify: camoAddBuiltRoutineToShopify,
  toggleRoutineCard: camoToggleRoutineCard,
  recalculateRoutineTotal: camoRecalculateRoutineTotal,
  toggleMoreReviews: camoToggleMoreReviews,
  filterReviews: camoFilterReviews,
  toggleAllProductsGrid: camoToggleAllProductsGrid,
  openMobileNav: camoOpenMobileNav,
  closeMobileNav: camoCloseMobileNav,
  toggleDesktopDropdown: camoToggleDesktopDropdown,
  goToHeroSlide: camoGoToHeroSlide,
  nextHeroSlide: camoNextHeroSlide,
  prevHeroSlide: camoPrevHeroSlide,
  resetHeroAutoplay: camoResetHeroAutoplay
});

// Also expose directly on window root for maximum compatibility
window.camoAddToCart = camoAddToCart;
window.camoOpenCart = camoOpenCartDrawer;
window.camoCloseCart = camoCloseCartDrawer;
window.camoFilterProducts = camoFilterProducts;

// DOM Ready Initialization
document.addEventListener('DOMContentLoaded', () => {

  // Form submission interceptor for native product forms (Shopify / WooCommerce / Standalone)
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (form && (form.action.includes('/cart/add') || form.id === 'camoProductForm' || form.classList.contains('camo-product-form') || form.classList.contains('camo-card-form'))) {
      e.preventDefault();
      e.stopPropagation();
      
      const submitBtn = form.querySelector('button[type="submit"], #camoAddToCartBtn, .single_add_to_cart_button, .btn-terracotta');
      const origText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Añadiendo...';
      }
      
      const qtyInput = form.querySelector('input[name="quantity"], #productQty');
      const qty = (qtyInput ? parseInt(qtyInput.value) : 1) || 1;
      
      try {
        await camoAddToCart(form, qty, true);
      } catch (err) {
        console.error('Add to cart submit error:', err);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = origText || 'Añadir a la Cesta &rarr;';
        }
      }
    }
  });

  // Bind Cart Triggers
  // Global delegated click listener for any add-to-cart buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.camo-hover-cart-btn, .add_to_cart_button, .ajax_add_to_cart, [data-action="add-to-cart"], .single_add_to_cart_button');
    if (btn) {
      if (!btn.getAttribute('onclick')) {
        e.preventDefault();
        e.stopPropagation();
        camoAddToCart(btn, 1, true);
      }
    }
  });

  document.querySelectorAll('.open-cart-btn, [data-action="open-cart"], #headerCartBtn, .header-action-btn.open-cart-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      camoOpenCartDrawer();
    });
  });

  const cartCloseBtn = document.getElementById('cartCloseBtn');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', camoCloseCartDrawer);

  const cartBackdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop');
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', (e) => {
      if (e.target === cartBackdrop) camoCloseCartDrawer();
    });
  }

  // Bind Wishlist Triggers
  const openWishlistBtn = document.getElementById('openWishlistBtn');
  if (openWishlistBtn) {
    openWishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();
      camoOpenWishlistDrawer();
    });
  }

  const wishlistCloseBtn = document.getElementById('wishlistCloseBtn');
  if (wishlistCloseBtn) wishlistCloseBtn.addEventListener('click', camoCloseWishlistDrawer);

  const wishlistBackdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (wishlistBackdrop) {
    wishlistBackdrop.addEventListener('click', (e) => {
      if (e.target === wishlistBackdrop) camoCloseWishlistDrawer();
    });
  }

  // Bind Quick View Close
  const closeQuickViewBtn = document.getElementById('closeQuickViewBtn');
  const quickViewModal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  if (closeQuickViewBtn && quickViewModal) {
    closeQuickViewBtn.addEventListener('click', camoCloseQuickView);
    quickViewModal.addEventListener('click', (e) => {
      if (e.target === quickViewModal) camoCloseQuickView();
    });
  }

  // Intercept WooCommerce native AJAX added_to_cart event
  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
      camoFetchLiveCart(true);
    });
    jQuery(document.body).on('removed_from_cart', function() {
      camoFetchLiveCart(false);
    });
  }

  // Close desktop dropdown on click outside
  document.addEventListener('click', function(e) {
    const menu = document.getElementById('navDropdownMenu') || document.getElementById('desktopDropdownMenu');
    const dropdownWrap = document.getElementById('navCollectionsDropdown');
    if (menu && dropdownWrap && !dropdownWrap.contains(e.target)) {
      menu.classList.remove('is-open');
    }
  });

  // Hero Touch Gestures & Mouse Pause
  const heroSectionEl = document.getElementById('heroSection') || document.querySelector('.hero-section');
  if (heroSectionEl) {
    let touchStartX = 0;
    let touchEndX = 0;

    heroSectionEl.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    heroSectionEl.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      if (touchEndX < touchStartX - 45) {
        camoNextHeroSlide();
      }
      if (touchEndX > touchStartX + 45) {
        camoPrevHeroSlide();
      }
    }, { passive: true });

    heroSectionEl.addEventListener('mouseenter', () => {
      if (heroAutoplayTimer) clearInterval(heroAutoplayTimer);
    });

    heroSectionEl.addEventListener('mouseleave', () => {
      camoResetHeroAutoplay();
    });
  }

  // Start Autoplay
  camoResetHeroAutoplay();

  // Announcement Bar Slider Loop
  const announcementSlider = document.getElementById('announcementSlider') || document.querySelector('.announcement-slider');
  if (announcementSlider) {
    const slides = announcementSlider.querySelectorAll('.announcement-slide');
    if (slides.length > 1) {
      let currentAnnounce = 0;
      setInterval(() => {
        currentAnnounce = (currentAnnounce + 1) % slides.length;
        const slideH = slides[0].offsetHeight || 36;
        announcementSlider.style.transform = `translateY(-${currentAnnounce * slideH}px)`;
      }, 3500);
    }
  }

  // Checkout Button Action
  const checkoutBtn = document.getElementById('checkoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.checkout_url) {
        window.location.href = window.CAMO_WP.checkout_url;
      } else if (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/')) {
        window.location.href = '/checkout';
      } else {
        // Standalone simulation or direct checkout
        camoShowToast('🔒 Iniciando pasarela de pago seguro SSL...');
        setTimeout(() => {
          if (typeof window !== 'undefined' && window.location.hostname.includes('myshopify.com')) {
            window.location.href = '/checkout';
          }
        }, 600);
      }
    });
  }

  // Promo Code Button Action
  const applyPromoBtn = document.getElementById('applyPromoBtn');
  const promoInput = document.getElementById('promoCodeInput');
  if (applyPromoBtn && promoInput) {
    applyPromoBtn.addEventListener('click', () => {
      const code = (promoInput.value || '').trim().toUpperCase();
      if (!code) {
        camoShowToast('Introduce un código de descuento');
        return;
      }
      if (code === 'CAMO10' || code === 'CAMO15' || code === 'BEAUTY10') {
        camoShowToast(`✓ Código ${code} aplicado correctamente`);
        const discRow = document.getElementById('cartDiscountRow');
        const discAmount = document.getElementById('cartDiscountAmount');
        if (discRow && discAmount) {
          discRow.style.display = 'flex';
          discAmount.textContent = code === 'CAMO15' ? '-15%' : '-10%';
        }
      } else {
        camoShowToast('Código de descuento no válido o caducado');
      }
    });
  }

  // Initial Cart Fetch & Wishlist Render
  camoFetchLiveCart(false);
  camoPreloadShopifyVariants();
  camoRenderWishlist();
});
